export default __webpack_public_path__ + "static/media/main_section16.43be2d4e.jpg";